import React from 'react'
import Image, { StaticImageData } from 'next/image'
import styles from './LanguageSelectorOption.module.scss'

interface LanguageSelectorOptionProps {
  item: {
    src: StaticImageData,
    alt: string
    label: string
  }
}

const LanguageSelectorOption: React.FC<LanguageSelectorOptionProps> = ({ item }) => {
  return <h3>
    <Image src={item.src} alt={item.alt} />
    &nbsp;<span className={styles.languageText}>{item.label}</span>
  </h3>
}

export default LanguageSelectorOption
